export const GERMAN_LOCALE = 'de-DE';
export const GERMAN_TIMEZONE = 'Europe/Berlin';
